// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoBottom_root__2sHHp {\n  width: 70px;\n  z-index: 10000;\n  margin-left: 5px; }\n\n.logoBottom_loader__UMgdQ {\n  width: 140px;\n  display: block;\n  position: static; }\n", ""]);
// Exports
exports.locals = {
	"root": "logoBottom_root__2sHHp",
	"loader": "logoBottom_loader__UMgdQ"
};
module.exports = exports;
